module.exports = __webpack_public_path__ + "static/media/Montserrat-Bold.ade91f47.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Montserrat-Bold.ttf
// module id = 548
// module chunks = 0